module.exports = __webpack_public_path__ + "static/media/footer-logo.147c34f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo.svg
// module id = 50
// module chunks = 0